"use strict";
function getNativeStreamCreator(streamType, deliveryType) {
    var NativeStream = (function () {
        function NativeStream(mediaStreams, emit) {
            this.mediaStreams = mediaStreams;
            this.emit = emit;
            this.currentLevel = 0;
        }
        NativeStream.prototype.attach = function (videoElement) {
            videoElement.src = this.mediaStreams[this.currentLevel].url;
            this.emit('levels', this.mediaStreams.map(function (mediaStream) {
                return { name: mediaStream.name || mediaStream.url };
            }));
            this.emit('currentLevel', this.currentLevel);
        };
        NativeStream.prototype.detach = function (videoElement) {
            videoElement.src = '';
        };
        NativeStream.prototype.getMediaStreamDeliveryType = function () {
            return deliveryType;
        };
        NativeStream.isSupported = function (env) {
            return env[streamType];
        };
        ;
        NativeStream.canPlay = function (mediaType) {
            return mediaType === streamType;
        };
        NativeStream.prototype.setMediaLevel = function (newLevel, videoElement) {
            if (newLevel < this.mediaStreams.length) {
                this.currentLevel = newLevel;
                var timeBeforeSwitch = videoElement.currentTime;
                videoElement.src = this.mediaStreams[this.currentLevel].url;
                videoElement.currentTime = timeBeforeSwitch;
                this.emit('currentLevel', this.currentLevel);
            }
        };
        return NativeStream;
    }());
    return NativeStream;
}
exports.getNativeStreamCreator = getNativeStreamCreator;
//# sourceMappingURL=native-stream.js.map


//////////////////
// WEBPACK FOOTER
// ./~/vidi/dist/src/media-streams/playable-streams/native-stream.js
// module id = 1422
// module chunks = 0 1 2 3